/* DOT site v3 — GSAP interactivity layer
   Requires assets/gsap.min.js + ScrollTrigger.min.js + MotionPathPlugin.min.js loaded first.
   Degrades silently: no GSAP or prefers-reduced-motion → static site. */
(function () {
  'use strict';
  if (typeof gsap === 'undefined') return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

  const CP = '<svg viewBox="0 0 24 24" fill="none" stroke="#9A4417" stroke-width="1.4"><circle cx="12" cy="12" r="9"/><path d="M12 7v10M7 12h10" stroke-linecap="round"/></svg>';

  /* ---------- floating ⊕ particles (containers marked .fx-float) ---------- */
  document.querySelectorAll('.fx-float').forEach(box => {
    const light = box.classList.contains('fx-light'); // over dark media → light particles
    for (let i = 0; i < 8; i++) {
      const d = document.createElement('div');
      d.className = 'fxp';
      d.innerHTML = CP;
      const s = 14 + Math.random() * 26;
      Object.assign(d.style, {
        position: 'absolute', width: s + 'px', height: s + 'px',
        left: (4 + Math.random() * 92) + '%', top: (4 + Math.random() * 88) + '%',
        opacity: .08 + Math.random() * .14, pointerEvents: 'none', zIndex: 1,
      });
      if (light) d.querySelector('svg').setAttribute('stroke', '#EE9856');
      box.appendChild(d);
      gsap.to(d, {
        y: (Math.random() < .5 ? -1 : 1) * (14 + Math.random() * 26),
        x: (Math.random() < .5 ? -1 : 1) * (8 + Math.random() * 18),
        rotation: (Math.random() < .5 ? -1 : 1) * (10 + Math.random() * 30),
        duration: 4 + Math.random() * 5,
        yoyo: true, repeat: -1, ease: 'sine.inOut', delay: Math.random() * 3,
      });
    }
  });

  /* ---------- hero parallax (video drifts + scales as you scroll away) ---------- */
  const heroMedia = document.querySelector('.hero video, .hero > img.bg, .hero-lp img.bg');
  if (heroMedia) {
    gsap.to(heroMedia, {
      yPercent: 14, scale: 1.08, ease: 'none',
      scrollTrigger: { trigger: heroMedia.closest('.hero, .hero-lp'), start: 'top top', end: 'bottom top', scrub: true },
    });
  }

  /* ---------- product-panel images: slow drift on scroll ---------- */
  document.querySelectorAll('.panelblock img, .use img').forEach(img => {
    gsap.fromTo(img, { yPercent: -5, scale: 1.06 }, {
      yPercent: 5, ease: 'none',
      scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: true },
    });
  });

  /* ---------- landing: the ⊕ travels a path, lighting each feature ---------- */
  const fxpath = document.getElementById('fxpath');
  if (fxpath) {
    const section = fxpath.closest('.fx-journey');
    const path = fxpath.querySelector('#fxp');
    const dot = fxpath.querySelector('#fxdot');
    const feats = section.querySelectorAll('.feature');

    // stretch the SVG to the section's real size (pixel-true — no distortion)
    const fit = () => {
      const h = section.scrollHeight, w = section.clientWidth;
      if (w < 200 || h < 400) return false; // layout not settled yet
      fxpath.setAttribute('viewBox', `0 0 ${w} ${h}`);
      fxpath.style.height = h + 'px';
      // gentle S-curve down the section (weaves both sides — RTL friendly)
      const c = w / 2, l = w * .12, r = w * .88;
      path.setAttribute('d',
        `M ${c} 0 C ${r} ${h * .12}, ${l} ${h * .22}, ${c} ${h * .34}
         C ${r} ${h * .46}, ${l} ${h * .56}, ${c} ${h * .68}
         C ${r} ${h * .80}, ${w * .35} ${h * .88}, ${c} ${h * .98}`);
      return true;
    };

    // MotionPath caches the path at tween creation → rebuild tweens on any resize
    let dotTween = null, drawTween = null, lastKey = '';
    const build = () => {
      if (!fit()) return;
      const key = fxpath.getAttribute('viewBox');
      if (key === lastKey) return;
      lastKey = key;
      if (dotTween) { dotTween.scrollTrigger && dotTween.scrollTrigger.kill(); dotTween.kill(); }
      if (drawTween) { drawTween.scrollTrigger && drawTween.scrollTrigger.kill(); drawTween.kill(); }
      dotTween = gsap.to(dot, {
        motionPath: { path: path, align: path, alignOrigin: [.5, .5] },
        ease: 'none',
        scrollTrigger: { trigger: section, start: 'top 55%', end: 'bottom 85%', scrub: .4 },
      });
      const len = path.getTotalLength();
      gsap.set(path, { strokeDasharray: len, strokeDashoffset: len });
      drawTween = gsap.to(path, {
        strokeDashoffset: 0, ease: 'none',
        scrollTrigger: { trigger: section, start: 'top 55%', end: 'bottom 85%', scrub: .4 },
      });
      ScrollTrigger.refresh();
    };
    build();
    addEventListener('load', build);
    if (typeof ResizeObserver !== 'undefined') {
      let t;
      new ResizeObserver(() => { clearTimeout(t); t = setTimeout(build, 200); }).observe(section);
    }
    // light features as the dot passes
    feats.forEach(f => {
      ScrollTrigger.create({
        trigger: f, start: 'top 62%', end: 'bottom 45%',
        onToggle: self => f.classList.toggle('lit', self.isActive),
      });
    });
  }

  /* ---------- stat numbers count up ---------- */
  document.querySelectorAll('.stat .dotnum').forEach(el => {
    const m = el.textContent.trim().match(/^(\d+)(.*)$/);
    if (!m) return;
    const target = +m[1], suffix = m[2] || '';
    const o = { v: 0 };
    ScrollTrigger.create({
      trigger: el, start: 'top 85%', once: true,
      onEnter: () => gsap.to(o, {
        v: target, duration: 1.4, ease: 'power2.out',
        onUpdate: () => { el.textContent = Math.round(o.v) + suffix; },
      }),
    });
  });
})();
